import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15623e6f&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=15623e6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15623e6f",
  null
  
)

/* custom blocks */
import block0 from "~/lang/privacyPolicy?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231208114810%2Fpages%2Fprivacy%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsYoutubeVideo: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/youtube-video.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/site/feefo.vue').default})
